/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Format_Code_ErrorInputs */

const en_format_code_error = /** @type {(inputs: Format_Code_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code could not be formatted. Check for syntax errors and try again.`)
};

const nl_format_code_error = /** @type {(inputs: Format_Code_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De code kon niet worden geformatteerd. Controleer op syntaxisfouten en probeer het opnieuw.`)
};

/**
* | output |
* | --- |
* | "Code could not be formatted. Check for syntax errors and try again." |
*
* @param {Format_Code_ErrorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const format_code_error = /** @type {((inputs?: Format_Code_ErrorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Format_Code_ErrorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_format_code_error(inputs)
	return en_format_code_error(inputs)
});